import { z } from "zod";
export const workflowPluginSourcePayloadSchema = z.object({
    arguments: z.record(z.string(), z.json()),
}).strict();
export const workflowPluginSourceAuthoritySchema = z.object({
    kind: z.literal("plugin_read"), pluginSlug: z.string().min(1),
    pluginVersion: z.string().min(1), toolName: z.string().min(1),
    reviewedDefinitionHash: z.string().regex(/^[0-9a-f]{64}$/u),
    schemaDigest: z.string().regex(/^[0-9a-f]{64}$/u),
}).strict();
export const workflowSourceCapabilityDescriptorSchema = z.object({
    kind: z.enum(["connector_entity", "channel_dataset", "file_upload", "plugin_read"]),
    roles: z.array(z.enum(["root", "related", "evidence", "lookup"])),
    triggers: z.array(z.enum(["source_change", "incremental"])),
    reads: z.enum(["paged_relation", "document_extraction", "reviewed_tool"]),
    requires: z.array(z.string()),
}).strict();
/** One selected operation and its execution adapter, without unrelated catalogue entries. */
export function workflowPluginAuthorityDefinition(plugin, tool) {
    return { pluginSlug: plugin.slug, pluginVersion: plugin.version,
        tool, policy: plugin.policy, mcp: plugin.mcp,
        adapters: (plugin.adapters ?? []).filter(adapter => adapter.slug === tool.adapterSlug) };
}
export const WORKFLOW_SOURCE_CAPABILITIES = [
    { kind: "connector_entity", roles: ["root", "related", "evidence", "lookup"],
        triggers: ["incremental"], reads: "paged_relation", requires: ["current_data_role", "fresh_connector"] },
    { kind: "channel_dataset", roles: ["root", "lookup"], triggers: ["incremental"], reads: "paged_relation",
        requires: ["channel_access", "initial_poll_processes_existing_rows", "current_publication_and_underlying_data_roles_for_source_backed_datasets"] },
    { kind: "file_upload", roles: ["root", "evidence"], triggers: ["source_change"],
        reads: "document_extraction", requires: ["channel_access"] },
    { kind: "plugin_read", roles: ["lookup"], triggers: [], reads: "reviewed_tool",
        requires: ["pinned_plugin_version", "pinned_reviewed_tool", "read_without_egress", "current_execution_grant"] },
];
